// extracted by mini-css-extract-plugin
export default {"container":"SubjectsContent_container__z8Q8j","list":"SubjectsContent_list__omoyo","left":"SubjectsContent_left__TyWij","right":"SubjectsContent_right__5tsF0"};